import { DASHWV_MA, DASHWV } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';

const multipleaudio = {};

// DASHWV
multipleaudio.DASHWV = {};
multipleaudio.DASHWV.vod = true;
multipleaudio.DASHWV.live = true;
multipleaudio.DASHWV.timeshift = true;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
// TODO validar si es correcto 
supported_stream_types.vod = [DASHWV_MA, DASHWV];
supported_stream_types.live = [ DASHWV];
supported_stream_types.timeshift = [DASHWV];

export default {
  appKey: '98984f29b824161363c7f63b7c900098', // TODO ESTO ES DE NAGRA
  appSubkey: 'amazon',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */
//Todo si los cambio falla dice la launcher device no soportado
  device_manufacturer: 'Amazon',
  device_model: 'firetv',
  device_name: 'firetv',
  device_so: deviceInfo.os.description || 'firetv',
  device_type: 'tv',
  stream_type: 'dashwv',
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  nodetv: 'tv',
  akamai_id: 'KeplerSTV',
  useEpgPostals: true,
  // akamai_mfwk: 'mfwktv2samsung-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkandroidtv-api.clarovideo.net' : 'http://mfwkandroidtv-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/kepler/config.js